import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    lang: "ar",
    arTast: true,
    modal: false,
    message: ""
}

const mutations = {
    changeModal(state, message) {
        state.modal = !state.modal;
        state.message = message
    }
}

const getters = {

}

export default new Vuex.Store({
    state,
    mutations,
    getters
})